import React from 'react';
import { render } from '@testing-library/react';
import { Takeover } from './Takeover';
import { BodyText } from '../BodyText';
import { ButtonGroup } from '../ButtonGroup';
import { Button } from '../Button';

describe('Takeover', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container, baseElement } = render(
			<Takeover
				backLabel="Previous Page"
				title="Takeover Title"
				footer={
					<ButtonGroup>
						<Button>Cancel</Button>
						<Button primary>Save</Button>
					</ButtonGroup>
				}
				footerAlign="right"
				data-auto-sel="automation-selector"
			>
				<BodyText>Takeover Content</BodyText>
			</Takeover>
		);

		/**
		 * NOTE: Using "baseElement" instead of "container" because
		 *       Takeover is rendered in a portal
		 */
		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
